(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'changeSettings'
	})

	.controller('NotificationSettingsController', NotificationSettingsController);

	NotificationSettingsController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'NotificationSettings', 'GlobalValues',
			'EntityPermissions', 'ScreenLog', 'DateUtils','$uibModalInstance','$stateParams','$rootScope','entityConstants' ];

	function NotificationSettingsController($scope, $state, workflowSharedService,
        NotificationSettings, GlobalValues, EntityPermissions, ScreenLog, DateUtils,$uibModalInstance,$stateParams,$rootScope,entityConstants) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.notificationSettings = {};
		vm.save = save;
		vm.userId = $stateParams.userId;
		vm.restoreDefault = restoreDefault;
		vm.launch = launch;
		vm.clear = clear;
		workflowSharedService.viewFrom = 'changeSettings';
		vm.isShowRegistrationSettings = true;
		 vm.bankId = vm.globalValues.getBankId();
		 vm.isShowOrderSettings=true;
		function launch() {
			$state.go("notification-settings");
		}
		logScreenAccess();
		loadAll();

		function loadAll() {
			NotificationSettings.get({
				"bankId" : vm.bankId
			},onGetNotificationSettingsSuccess, onGetNotificationSettingsError);
		}

		function onGetNotificationSettingsSuccess(result) {
			vm.notificationSettings = result;
			if(vm.notificationSettings.IsTradeEmailToBeSent==null || vm.notificationSettings.IsTradeEmailToBeSent == undefined)
				{
				vm.notificationSettings.IsTradeEmailToBeSent='Yes';
				}
	
		}

		function onGetNotificationSettingsError() {

		}
		
		function restoreDefault() {
			loadAll();
		}
		
	
		function save() {
			var fd = new FormData();
			
			vm.user.dob = DateUtils.convertLocalDateToServer(vm.user.dob);
			fd.append('user', JSON.stringify(vm.user));
            
			console.log(fd);

			NotificationSettings.update( fd, onSaveSuccess, onSaveError);
			
		}
		
		$rootScope.$on('Refresh', function(event, result) {
			loadAll();
		});
		
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
		}

		function onSaveError() {

			$scope.clicked = false;
		}
		function logScreenAccess(){
	       	ScreenLog.screenLog(entityConstants.ENTITY_SHORT_NAME.NOTIFICATION_SETTINGS ,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	    }

	}
})();
